//  Name: course-payment
import { mapGetters } from 'vuex'
import EventBus from '@/helpers/event-bus'
import CreditCard from '@/components/paypal-credit-card'

export default {
  data () {
    return {
      course: null
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    price () {
      let amount = 0
      if (this.course.price.length === 1) {
        amount = this.course.price[0].number
      } else {
        for (var index in this.course.price) {
          if (this.course.price[index].type === 2) {
            amount = this.course.price[index].number
            break
          }
        }
      }
      return amount
    }
  },
  methods: {
    notifyPay (type) {
      var vm = this
      EventBus.$emit('waitMessage')
      return new Promise((resolve, reject) => {
        vm.$http.post(
          'courses/notify/',
          {
            user: vm.user.id,
            course: vm.course.id,
            type: type,
            amount: vm.price
          }
        ).then(response => {
          resolve(response)
        }, (error) => {
          console.error(error)
          EventBus.$emit('errorMessage', 'Ocurrió un problema de comunicación con el servidor')
          reject()
        })
      })
    },
    payWesternUnion () {
      let vm = this
      vm.notifyPay(1).then(() => {
        vm.$router.push({name: 'Gracias'})
      }, error => {
        console.log('Explosito!!!', error)
      })
    },
    payBCP () {
      let vm = this
      vm.notifyPay(3).then(() => {
        vm.$router.push({name: 'Gracias'})
      }, error => {
        console.log('Explosito!!!', error)
      })
    },
    payBIG () {
      let vm = this
      vm.notifyPay(3).then(() => {
        vm.$router.push({name: 'Gracias'})
      }, error => {
        console.log('Explosito!!!', error)
      })
    }
  },
  mounted () {
    var course = window.localStorage.getItem('course_pay', null)
    if (course) {
      this.$set(this, 'course', JSON.parse(course))
    }
  },
  components: {
    CreditCard
  }
}



// WEBPACK FOOTER //
// ./src/pages/course-payment/script.js